// extracted by mini-css-extract-plugin
export default {"Icon":"EngagementMaterialView_Icon__Ak0J2","fileName":"EngagementMaterialView_fileName__PLlg6"};